export default {"src":"/_next/static/media/fossgis.49ef86b9.svg","height":194,"width":639,"blurWidth":0,"blurHeight":0};